<template>
    <div class="ur-time-picker ur-input" v-if="isStepper" :class="'ur-time-picker--'+$_size" >
        <div :class="'ur-time-picker-time--'+$_size">
            <aicc-time-stepper ref="hourTimeStepper" v-model="time_hour" center :min="containMrdm ? 1 : 0" :max="containMrdm? 12 : 23" controlType="updown" repeat :size="$_size"
                    @change="(curr,prev)=>{ this.onChangeHandler('hour', curr, true)}"
                    @input="v=>{ this.onChangeHandler('hour', v, false)}"
                    :disabled="disabled"></aicc-time-stepper><span style="margin-left:4px; margin-right:4px">:</span>
            <aicc-time-stepper ref="minuteTimeStepper" v-model="time_minute" center min="0" max="59" controlType="updown" repeat :size="$_size"
                    @change="(curr,prev)=>{ this.onChangeHandler('min',curr, true)}"
                    @input="v=>{ this.onChangeHandler('min', v, false)}"
                    :disabled="disabled"></aicc-time-stepper>
        </div>
        <ur-segment-wrapper v-show="containMrdm" :class="'ur-time-picker-meridiem--'+$_size" primary v-model="mrdm" :disabled="disabled"
                                                            @input="v=>{this.onChangeHandler('mrdm',v)}">
            <ur-segment-button value="AM" ref="urAMBtn"  :size="$_size">AM</ur-segment-button>
            <ur-segment-button value="PM" ref="urPMBtn" :size="$_size">PM</ur-segment-button>
        </ur-segment-wrapper>
    </div>
    <div class="ur-time-picker ur-input" v-else :class="'ur-time-picker--'+$_size">
        <ur-dropdown :items="timeList" :value="dropValue" :size="$_size" @input="v=>{ this.onChangeHandler('dropdown', v)}"></ur-dropdown>
<!--        <ur-dropdown :items="time_list" :value="dropValue" @input="v=>{ this.onChangeHandler('dropdown', v)}"></ur-dropdown>-->
    </div>
</template>

<script>
// ur-time-picker는 시간을 나타내는 component입니다
// #ur-time-picker is a component that represents time
import aiccTimeStepper from './AICCTimeStepper';

export default {
    name :'aicc-time-picker',
    components:{
        aiccTimeStepper,
    },
    props :{
        // $ver: v0.1.2
        // $v-model
        // 선택된 시간을 나타내는 값입니다. model-type props의 설정에 따라
        // "hh:mm:sss meridiem" format의 문자열로 반환됩니다.
        // #A value representing the selected time. Depending on the model-type props setting,
        // #it is returned as a string "hh:mm:sss meridiem" format you set.
        // $tags IDE, value
        value: {
            type: [String,Number],
            required: true
        },

        // $ver: v0.1.0
        // 오전/오후 속성 입니다. 'AM', 'PM' 중 한 가지 속성 값을 가집니다.
        // #AM / PM property. It has one attribute value: "AM" or "PM".
        // $tags IDE, meridiem
        meridiem: {type: String, default: 'AM'},

        // $ver: v0.1.0
        // 비활성화 상태로 전환합니다.
        // #Switch to inactive state.
        // $default: false
        // $tags IDE, disabled
        disabled: {type:Boolean, default: false},

        // $ver: v0.2.0
        // 크기 입니다. 'medium','small' 두 가지 중 하나를 입력해야 합니다.
        // #The size You must enter one of two types: medium or small.
        // $default: medium
        // $tags IDE, size
        size: {
            validator: function (value) {
                // The value must match one of these strings
                return ['medium', 'small'].indexOf(value) !== -1
            },
            // type: String,
            //default: 'medium'
        },

        // $ver: v0.2.0
        // 컨트롤의 크기를 Medium 사이즈로 조정합니다.
        // #Resize the control to Medium size.
        // $default: false
        medium: {type:Boolean, default: false},
        // $abbr: medium
        md: {type:Boolean, default: false},

        // $ver: v0.2.0
        // 컨트롤의 크기를 Small 사이즈로 조정합니다.
        // #Resize the control to Small size.
        // $default: false
        small: {type:Boolean, default: false},
        // $abbr: small
        sm: {type:Boolean, default: false},

        // $ver: v0.2.0
        // Time Picker를 Dropdown 형태로 사용한다.
        // #Defined dropdown shape of Time picker.
        // $default: false
        // $tags IDE, mode
        mode: {type:String, default: 'stepper'},

        // $ver: v0.2.0
        // Time Picker가 Dropdown 형태일 시에 분(minute)의 텀.
        // #Defined dropdown type time(minute) term.
        // $default: 30
        // $tags IDE, term
        term: {
            type:[Number, String],
            default: 30,
            validator: function (value) {
                // The value must match one of these strings
                return [1,5,10,30,60,'1','5','10','30','60'].indexOf(value) !== -1
            },
        },

        // $ver: v0.2.1
        // 시간의 오전 오후 표시 여부입니다.
        // #Whether it is displayed in the morning/afternoon.
        // $default: true
        // $tags IDE, term
        containMrdm: {
            type:Boolean,
            default: true,
        },

        // HH:mm 두 자릿 수 표기
        // fullTimeText:{
        //     type:Boolean,
        //     default:false,
        // },

        // 시, 분 중 하나라도 빈 문자열이면 빈 문자열을 반환
        anyEmptyAllEmpty:{
            type:Boolean,
            default:false,
        },
    },
    data() {
        return {
            default: {
                size: 'medium'
            },
            time_hour : this.hour,
            time_minute: this.minute,
            mrdm : this.meridiem,
            time_list : [],
            time_list_24 : [],
            dropValue: {}
        }
    },
    mounted(){
        if(!this.isStepper){
            let term = Number(this.term);
            let locationCount = (60/term);

            for(let ampm = 0; ampm < 2; ampm++){
                let AMPM = (ampm === 0)? 'AM' : 'PM';
                for(let j = 0; j < locationCount; j++){
                    this.time_list.push(
                        {value: {hour: 12, min: (j*term), mrdm: AMPM}, text: '12: '+ this.getTimeText(j*term) + ' ' + AMPM}
                    )
                }
                for(let i = 1; i < 12; i++){
                    for(let j = 0; j < locationCount; j++){
                        this.time_list.push(
                            {value: {hour: i, min: (j*term), mrdm: AMPM}, text: i+': '+ this.getTimeText(j*term) + ' ' + AMPM}
                        )
                    }
                }
            }
            for(let i = 0 ; i < 24 ; i++) {
                for(let j = 0; j < locationCount; j++){
                    this.time_list_24.push(
                        //{value: {hour: i, min: (j*term)}, text: i+': '+ this.getTimeText(j*term)}
                        {value: {hour: i, min: (j*term)}, text: this.getTimeText(i)+':'+ this.getTimeText(j*term)}
                    )
                }
            }
            if(!!this.value){
                let tmpTime = this.value.split(/[ :]/);
                this.timeList.forEach(time => {
                    if(time.value.hour !== Number(tmpTime[0])
                            || time.value.min !== Number(tmpTime[1])
                            || (this.containMrdm && time.value.mrdm !== tmpTime[3])) {return false}
                    this.dropValue = time.value;
                    return true;
                })
            }
        }
    },
    computed:{
        $_size() {
            if((this.size && this.small) || (this.size && this.medium)){
                console.warn("Props related size are duplicated.")
            }
            switch(this.size){
                case 'small':   return 'small';
                case 'medium' : return 'medium';
            }

            if(this.medium || this.md) {return 'medium'}
            if(this.small || this.sm) {return 'small'}
            if(this.urInput) {return this.urInput.size}
            return this.default.size;
        },
        isStepper(){
            return this.mode === 'stepper'
        },
        timeList() {
            return this.containMrdm ? this.time_list : this.time_list_24;
        }
    },
    watch:{
        value: {
            immediate: true,
            handler(val){
                // console.log("watch value", val);
                if(!val) return;
                let tmp = val.split(/[: ]/);
                this.time_hour = this.getTimeText(tmp[0]);
                this.time_minute = this.getTimeText(tmp[1]);
                this.mrdm = tmp[3];
                this.dropValue = this.findItem(tmp[0] * 1, tmp[1] * 1, tmp[3]);
            }
        },
    },
    methods : {
        findItem(hour, min, mrdm) {
            for(let i = 0; i < this.timeList.length; i ++ ){
                let time = this.timeList[i].value;
                if(time.hour === hour && time.min === min && (this.containMrdm ? time.mrdm === mrdm : true)){
                    return time;
                }
            }
            return null;
        },
        isNumeric(txt){
            return !isNaN(Number(txt));
        },
        getTimeText(txt){
            let val = this.isNumeric(txt) ? Number(txt) : 0;
            return (val < 10)? '0'+val : ''+val;
        },
        onChangeHandler(mode, val, stepperClick){
            // console.log("onChangeHandler", mode, val, stepperClick);
            if(this.anyEmptyAllEmpty && val === "") {
                // 하나라도 빈 문자열이면 시, 분 모두 빈 문자열로 보이게 한다.
                this.time_hour = "";
                this.time_minute = "";
                // mode가 뭐든 빈 문자열이면 빈 문자열로 이벤트를 올려보낸다.
                this.$emit('input', val);
                return;
            }

            if(mode === 'hour'){
                let nextFocus = false;
                let hour = this.setHourRange(val);
                let hh = this.getTimeText(hour);
                // $ver: v0.2.0
                // $arg: selected item(s))
                // 시간 값이 바뀔 때, 현재 시간 값을 (HH:MM AM) 형태의 파라미터로 이벤트를 발생시킵니다.`
                // #When the time value is changed, an event is generated with the current time value as a parameter of the form (HH: MM AM).
                if(val.length > 1 || hour > 9) {
                    nextFocus = true;
                }
                // console.log("this.time_minute", this.time_minute);
                // if(this.time_minute) {   // 이 if절 열면 time_minute가 0일 때는 이벤트가 올라가지 않더라.
                    this.$emit('input', this.getValue(hh, this.time_minute));
                // }
                if(stepperClick === false && nextFocus === true) {
                    this.$refs['minuteTimeStepper'].focus();
                }
            }else if(mode ==='min') {
                let min = this.setMinuteRange(val);
                let mm = this.getTimeText(min);
                // $ver: v0.2.0
                // $arg: selected item(s))
                // 시간 값이 바뀔 때, 현재 시간 값을 (HH:MM AM) 형태의 파라미터로 이벤트를 발생시킵니다.
                // #When the time value is changed, an event is generated with the current time value as a parameter of the form (HH: MM AM).
                // console.log("this.time_hour", this.time_hour);
                // if(this.time_hour) {   // 이 if절 열면 time_hour가 0일 때는 이벤트가 올라가지 않더라.
                    this.$emit('input', this.getValue(this.time_hour, mm));
                // }
            }else if(mode === 'dropdown'){
                this.dropValue = val;
                this.$emit('input', this.getTimeText(val.hour) + ":" + this.getTimeText(val.min) + ":00" + (this.containMrdm ? ' ' + val.mrdm : ''));
            }else{
                this.$emit('input', this.getValue(this.time_hour, this.time_minute));
            }
        },
        setHourRange(val){
            let hour =  Number(val);
            if(this.containMrdm) {
                if (hour === 0 || hour === 13) {
                    if(this.mrdm === 'AM') {this.mrdm = 'PM';}
                    else{this.mrdm = 'AM';}
                }
                if (hour >= 13) { hour= 1; }
                else if (hour <= 0) { hour = 12; }
            } else {
                if (hour >= 24) { hour= 0; }
                else if (hour < 0) { hour = 23; }
            }
            return hour;
        },

        setMinuteRange(val){
            let min =  Number(val);
            if (min < 0 || min >= 60) {
                min= 0;
            }
            return min;
        },

        getValue(hour, min){
            //return hour + ":" + min + ":00" + (this.containMrdm ? ' ' + this.mrdm : '');
            return this.getTimeText(hour) + ":" + this.getTimeText(min) + ":00" + (this.containMrdm ? ' ' + this.mrdm : '');
        }
    }
}
</script>
